import { SESSION_CODE } from "../helper/sessionCode";
//video-controller
export const PublicApi = {
  slider: (sectionType, size) =>
    `/api/slider/public/${sectionType}?size=${size}`,
  videos: (sectionType, size, channelId) => {
    let url = `/api/video/public/${sectionType}?size=${size}&code=${SESSION_CODE}`;
    if (channelId) {
      url += `&channelId=${channelId}`;
    }

    return url;
  },
  video: (id) => `/api/video/${id}`,
  videoPublicDetail: (id) => `/api/video/public/detail/${id}`,
  videosSearch: (attr) => {
    const params = new URLSearchParams();

    if (attr?.name) params.append("name", attr.name);
    if (attr?.page !== undefined) params.append("page", attr.page);
    if (attr?.size !== undefined) params.append("size", attr.size);
    if (attr?.categories !== undefined)
      params.append("categories", attr.categories);
    params.append("code", SESSION_CODE);

    return `/api/video/${attr?.sectionType}/search?${params.toString()}`;
  },
  videosSearchPublic: (attr) => {
    const params = new URLSearchParams();

    if (attr?.name) params.append("name", attr.name);
    if (attr?.page !== undefined) params.append("page", attr.page);
    if (attr?.size !== undefined) params.append("size", attr.size);
    if (attr?.categories !== undefined)
      params.append("categories", attr.categories);
    params.append("code", SESSION_CODE);

    return `/api/video/public/${attr?.sectionType}/search?${params.toString()}`;
  },
  reels: (attr) => {
    const params = new URLSearchParams();

    if (attr?.sectionType) params.append("sectionType", attr.sectionType);
    if (attr?.page !== undefined) params.append("page", attr.page);
    if (attr?.size !== undefined) params.append("size", attr.size);
    if (attr?.id !== undefined) params.append("id", attr.id);

    params.append("code", SESSION_CODE);

    const query = params.toString();
    return `/api/reel/public${query ? `?${query}` : ""}`;
  },
  bookmarkAdd: (id) => `/api/user/bookmark/${id}`,
  likeAdd: (id) => `/api/user/like/${id}`,
  reelLikeAdd: (id) => `/api/user/like/reel/${id}`,
  bookmarkList: (page, size) => `/api/user/bookmark?page=${page}&size=${size}`,

  searchVideos: (name, page, size, categories) => {
    const params = new URLSearchParams();

    if (name) params.append("name", name);
    if (page !== undefined) params.append("page", page);
    if (size !== undefined) params.append("size", size);
    if (categories !== undefined && categories !== "")
      params.append("categories", categories);

    params.append("code", SESSION_CODE);

    return `/api/video/public/search?${params.toString()}`;
  },
  searchChannels: (name, page, size, categories) => {
    const params = new URLSearchParams();

    if (name) params.append("name", name);
    if (page !== undefined) params.append("page", page);
    if (size !== undefined) params.append("size", size);
    if (categories) params.append("categories", categories);

    params.append("code", SESSION_CODE);

    return `/api/channel/public/search?${params.toString()}`;
  },

  channels: (page, size) =>
    `/api/channel/public/extended?page=${page}&size=${size}&code=${SESSION_CODE}`,
  channelListAll: () => `/api/channel/public?code=${SESSION_CODE}`,
  channelDetail: (id) => `/api/channel/${id}?code=${SESSION_CODE}`,
  channelDetailPublic: (id) => `/api/channel/public/${id}?code=${SESSION_CODE}`,

  cartAdd: () => `/api/cart/add`,
  cartRemove: (id) => `/api/cart/remove/${id}`,
  cartInfo: () => `/api/cart/info`,
  cartSize: () => `/api/cart/size`,
  finishCart: () => `/api/cart/finish`,

  categoryForm: (sectionType) => `/api/category/form/${sectionType}`,
  categoryFormPublic: (sectionType) => `/api/category/public/form/${sectionType}`,
  categorySearchForm: () => `/api/category/form`,
  categorySearchFormPublic: () => `/api/category/public/form`,
  course: (id) => `/api/course/${id}`,
  coursePublic: (id) => `/api/course/public/${id}`,
  videoMaster: (id) => `/api/video/master/${id}`,
  videoMasterPublicDetail: (id) => `/api/video/public/detail/master/${id}`,
  courseVideos2: () => `/api/course`,
  contact: () => `/api/contact/public`,
  contactEducator: () => `api/contact/public/educator`,

  JwPlayers: () => `/api/video/public/players`,
  videoJwt: (videoId) => `/api/video/public/jwt/${videoId}`,
  receiptList: (page, size) => `/api/receipt?page=${page}&size=${size}`,
  receiptDetail: (id) => `/api/receipt/${id}`,
  content: (type) => `/api/content/public/${type}`,

  statsLikeBookmark: (page, size) =>
    `/api/video/statistic/like-bookmark?page=${page}&size=${size}`,
  statsCountLike: () => `/api/video/statistic/count/like`,
  reelStats: (id) => `/api/reel/public/stats/${id}`,
  statsCountBookmark: () => `/api/video/statistic/count/bookmark`,
  bestLike: () => `/api/video/statistic/best-like`,
  bestBookmark: () => `/api/video/statistic/best-bookmark`,
  totalRevenue: () => `/api/user/statistic/total-revenue`,
  totalSales: () => `/api/user/statistic/total-sales`,
  montlyRevenue: (year) => `/api/user/statistic/monthly-revenue?year=${year}`,
  montlySales: (year) => `/api/user/statistic/monthly-sales?year=${year}`,
  montlySalesDetail: (year, month) =>
    `/api/user/statistic/monthly-sales-detail?year=${year}&month=${month}`,
  totalSalesDetail: () => `/api/user/statistic/total-sales-detail`,
  device: () => `/api/user/device`,
  deviceRemove: (id) => `/api/user/device/${id}`,

  courseVideos: (attr) => {
    const params = new URLSearchParams();

    if (attr?.name) params.append("name", attr.name);
    if (attr?.page !== undefined) params.append("page", attr.page);
    if (attr?.size !== undefined) params.append("size", attr.size);
    if (attr?.categories !== undefined)
      params.append("categories", attr.categories);
    params.append("code", SESSION_CODE);

    return `/api/course?${params.toString()}`;
  },
  subscriptionEarnings: () => `/api/subscription/analytics/educator/earnings`,
  subscriptionAnalyticsProfile: (startDate, endDate, options = {}) => {
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (options.summaryOnly) params.append("summaryOnly", "true");
    const query = params.toString();
    return query
      ? `/api/subscription/analytics/educator/profile?${query}`
      : `/api/subscription/analytics/educator/profile`;
  },
  subscriptionSubscribe: () => `/api/subscription/subscribe`,
  subscriptionMy: () => `/api/subscription/my`,
  subscriptionPurchaseComplete: (orderId) =>
    `/api/subscription/my/purchase-complete?orderId=${encodeURIComponent(
      orderId
    )}`,
  subscriptionPurchaseCompletePublic: () =>
    `/api/subscription/public/purchase-complete`,
  subscriptionSalesSignup: () => `/api/subscription/public/sales-signup`,
  subscriptionSalesCheckout: (token) =>
    `/api/subscription/public/sales-checkout/${encodeURIComponent(token)}`,
  subscriptionCheckoutRetry: () =>
    `/api/subscription/public/checkout-retry`,
  subscriptionSalesLogin: () => `/api/subscription/public/sales-login`,
  subscriptionPromoQuote: () => `/api/subscription/public/promo-code/quote`,
  subscriptionPromoQuoteAuthenticated: () => `/api/subscription/promo-code/quote`,
  subscriptionCancelRenewal: () => `/api/subscription/cancel-renewal`,
  subscriptionReactivate: () => `/api/subscription/reactivate`,
  subscriptionUpdatePaymentMethod: () =>
    `/api/subscription/update-payment-method`,
  subscriptionPayments: () => `/api/subscription/my/payments`,
  trackingClientError: () => `/api/tracking/public/client-error`,
  bestPlays: () => `/api/video/statistic/best-plays`,
  courseVideosPublic: (attr) => {
    const params = new URLSearchParams();

    if (attr?.name) params.append("name", attr.name);
    if (attr?.page !== undefined) params.append("page", attr.page);
    if (attr?.size !== undefined) params.append("size", attr.size);
    if (attr?.categories !== undefined)
      params.append("categories", attr.categories);
    params.append("code", SESSION_CODE);

    return `/api/course/public/search?${params.toString()}`;
  },
};
export const AdministratorAPI = {
  login: (rememberMe) => `/api/user/login?rememberMe=${rememberMe}`,
  loginGoolge: (rememberMe) => `/api/user/login/google?rememberMe=true`,
  logout: () => `/api/user/logout`,
  me: () => `/api/user/me`,
  register: () => `/api/user/register`,
  registerGoogle: () => `/api/user/register/google`,
  changeData: () => `/api/user/change-info`,
  changePassword: () => `/api/user/change-password`,
  resetPassword: () => `/api/user/public/send/reset-password`,
  verification: () => `/api/user/public/verify`,
  resetPasswordConfirm: () => `/api/user/public/verify/reset-password`,
  resendVerification: () => `/api/user/public/resend/verification`,
  info: () => `/api/user/info`,
  deactivateAccount: () => `/api/user/deactivate`,
  changeNewsletter: () => `/api/user/change-newsletter`,
  subscription: (page, size) =>
    `/api/user/subscription?page=${page}&size=${size}`,
};

export const AnalyticsAPI = {
  videoStats: (page, size) => `/api/video/analytic?page=${page}&size=${size}`,
  videoPublicStats: (page, size) =>
    `/api/video/analytic/mini-micro?page=${page}&size=${size}`,
};
